import React from 'react';
export function Footer() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-charcoal text-white pt-16 pb-8 border-t-4 border-primary" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-100">
          {/* Brand */}
          <div className="space-y-4" data-id="element-101">
            <div className="flex items-center gap-2 mb-6" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/s3bTrEvY6gpbmuLKno6jM2/KMC.png" alt="KMC Logo" className="h-10 w-auto brightness-0 invert" data-id="element-103" />
              <span className="text-xl font-bold tracking-wide text-white" data-id="element-104">
                KINGSBURY
              </span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-sm" data-id="element-105">
              Your trusted partner for Residential and Commercial Renovations,
              Construction & Maintenance Services. We identify issues, plan
              solutions, and execute high-quality repairs to keep your business
              running smoothly.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-106">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-107">Quick Links</h4>
            <ul className="space-y-3" data-id="element-108">
              <li data-id="element-109">
                <a href="#about" onClick={e => scrollToSection(e, '#about')} className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-110">
                  About Us
                </a>
              </li>
              <li data-id="element-111">
                <a href="#services" onClick={e => scrollToSection(e, '#services')} className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-112">
                  Our Services
                </a>
              </li>
              <li data-id="element-113">
                <a href="#why-us" onClick={e => scrollToSection(e, '#why-us')} className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-114">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-115">
                <a href="#commitment" onClick={e => scrollToSection(e, '#commitment')} className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-116">
                  Our Commitment
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-117">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-118">Contact</h4>
            <ul className="space-y-3 text-sm text-white/70" data-id="element-119">
              <li data-id="element-120">1-81 Milliken Blvd</li>
              <li data-id="element-121">Scarborough, ON M1V 1V3</li>
              <li className="pt-2" data-id="element-122">
                <a href="tel:4162089236" className="hover:text-white transition-colors" data-id="element-123">
                  Phone: 416 208 9236
                </a>
              </li>
              <li data-id="element-124">
                <a href="mailto:dencell.green@kingsburymc.com" className="hover:text-white transition-colors" data-id="element-125">
                  Email: dencell.green@kingsburymc.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-126">
          <p className="text-white/50 text-sm text-center md:text-left" data-id="element-127">
            © {new Date().getFullYear()} Kingsbury Maintenance & Construction.
            All rights reserved.
          </p>
          <p className="text-white/50 text-sm" data-id="element-128">
            Serving the Greater Toronto Area
          </p>
        </div>
      </div>
    </footer>;
}